import { TypeKeys, ActionTypes } from "../actions/index";

const getInitialState = (): AuthState => {
  return {
    authLoaded: false,
    isAuthenticated: false,
    user: {
      displayName: null,
      email: null,
      phoneNumber: null,
      photoURL: null,
      providerId: null,
      uid: null,
      providerData: [],
      emailVerified: null,
    },
    verifyEmailSent: true,
    shouldShowVerifyEmail: false,
    orgId: null,
    orgPermission: null,
    orgAdmin: null,
    orgOwner: null,
    curriculumOnly: null,
    sworkitAdmin: false,
    oAuthInitiated: null,
  };
};

const auth = (
  state: AuthState = getInitialState(),
  action: ActionTypes,
): AuthState => {
  switch (action.type) {
    case TypeKeys.SIGN_IN: {
      const { user, oAuthInitiated } = action;
      let shouldShowVerifyEmail = false;
      user.providerData?.map((provider) => {
        if (provider?.providerId === "password" && !user.emailVerified) {
          shouldShowVerifyEmail = true;
        }
      });
      const isProviderSignIn = Boolean(user.providerData?.length);
      const {
        orgAdmin,
        orgOwner,
        orgPermission,
        orgId,
        curriculumOnly,
        sworkitAdmin,
        loginValidUntil,
        firebase,
      } = action.claims || {};
      const signInProvider = firebase?.sign_in_provider;
      return {
        ...state,
        user,
        authLoaded: true,
        isAuthenticated: true,
        shouldShowVerifyEmail,
        orgPermission,
        orgAdmin,
        orgOwner,
        curriculumOnly,
        orgId,
        sworkitAdmin,
        oAuthInitiated,
        loginValidUntil,
        signInProvider,
        isProviderSignIn,
      };
    }
    case TypeKeys.SET_VERIFY_EMAIL_SENT: {
      return {
        ...state,
        verifyEmailSent: action.verifyEmailSent,
      };
    }
    case TypeKeys.SIGN_OUT: {
      const oAuthInitiated = state.oAuthInitiated;
      return { ...getInitialState(), authLoaded: true, oAuthInitiated };
    }
  }
  return state;
};

export default auth;
